import { AccesoEstado } from '../common/enumModel';
import { IFilterAccesoModel } from '../interfaces/accesos/IFilterAccesoModel';

export class FilterAccesoModel implements IFilterAccesoModel {
  nombreContratista: string;
  nombreEmpleado: string;
  nroDocumento: string;
  fechaInicioAprobacion?: Date;
  fechaFinAprobacion?: Date;
  page: number;
  pageSize: number;
  sedes: number[];
  idEstado: AccesoEstado;
  estados: number[];
  solicitante: string;
  codigoSolicitud: string;
  idCompania: number;
  subContratista: string;

  constructor() {
    this.nombreContratista = '';
    this.nombreEmpleado = '';
    this.nroDocumento = '';
    // fechaInicioAprobacion?: Date;
    // fechaFinAprobacion?: Date;
    this.page = 1;
    this.pageSize = 30;
    this.sedes = [];
    this.estados = [];
    this.idEstado = AccesoEstado.AUTORIZADO;
    this.solicitante = '';
    this.codigoSolicitud = '';
    this.idCompania = 0;
    this.subContratista = '';
  }
}
